import { render, staticRenderFns } from "./AppHeaderCompanyInfo.vue?vue&type=template&id=0a188284&scoped=true&"
import script from "./AppHeaderCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./AppHeaderCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderCompanyInfo.vue?vue&type=style&index=0&id=0a188284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a188284",
  null
  
)

export default component.exports